import { customFilterSelectStyles, Option } from "components/shared/select";
import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";
import { getFederalSubjects } from "sources/map";

const config = {
    regionId: {
        label: "Регион",
        styles: { ...customFilterSelectStyles },
        closeMenuOnSelect: true,
        inputProps: { name: "regionId" },
        isMulti: false,
        url: getFederalSubjects,
        propName: "name",
        components: { Option },
        validators: [requiredField],
        required: true,
        menuPortalTarget: document.body,
    },
    description: {
        label: "Описание",
        inputProps: { name: "description" },
        textarea: true,
        validators: [requiredField],
        required: true,
    },
    documentUrl: {
        label: "Ссылка на нормативный документ",
        inputProps: { name: "documentUrl" },
    },
    startedAt: {
        inPortal: true,
        label: "Дата начала",
        inputProps: { name: "startedAt", type: "date" },
        validators: [requiredField],
        required: true,
    },
    endedAt: {
        inPortal: true,
        label: "Дата окончания",
        inputProps: { name: "endedAt", type: "date" },
        validators: [requiredField],
        required: true,
    },
    id: {},
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
